import {
    IAttribute,
    ICopySinkWithUpdateMethod,
    IModel,
    TabularCopySink,
    UpdateMethod,
    UpdateMethodType
} from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { AzureCosmosDbV2Dataset } from 'app/model/dataset/azure-cosmos-db.v2.dataset';

import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cosmosSql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureCosmosDbV2Dataset) }
})
export class AzureCosmosDbV2Sink extends TabularCopySink implements ICopySinkWithUpdateMethod {
    public static readonly MODEL: IModel;
    public static readonly DISABLE_METRICS_COLLECTION: IAttribute;
    public static readonly WRITE_BEHAVIOR: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;

    @Metamodel.attribute({
        templatable: true,
        association: 'DISABLE_METRICS_COLLECTION',
        display: stringResources.CopySinkDisableMetricsCollectionLabel
    })
    public disableMetricsCollection: boolean;

    public get updateMethod(): UpdateMethodType {
        switch (this.writeBehavior) {
            case writeBehaviorOptionValues.insert:
                return UpdateMethod.Append;
            case writeBehaviorOptionValues.upsert:
                return UpdateMethod.Upsert;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Append:
                this.writeBehavior = writeBehaviorOptionValues.insert;
                break;
            case UpdateMethod.Upsert:
                this.writeBehavior = writeBehaviorOptionValues.upsert;
                break;
            default:
        }
    }
}
